<template>
  <div>
    <van-overlay :show="data.active">
      <div class="wrapper">
        <div class="block" style="padding: 0rem;overflow: hidden;">
          <van-form>
            <van-field
              readonly
              clickable
              v-model="choseType"
              label="類別"
              name="類別"
              @click="showFormType = true"
            />
            <van-field
              v-model="industryType"
              v-show="this.choseType=='合作洽談'"
              type="text"
              label="產業別"
              placeholder="選填"
            />
            <van-field v-model="realName" type="text" label="真實姓名" placeholder="選填" />
            <van-field v-model="realTel" type="tel" label="手機號碼" placeholder="選填" />
            <van-field
              v-model="notifyMessage"
              rows="3"
              autosize
              label="內容"
              type="textarea"
              placeholder="內容....."
              :border="false"
              style="border-radius: 10px;"
            />
            <div style="border-top-style: solid;border-width: 1px;">
              <div style="width: 50%;display: inline-block;">
                <van-button
                  @click="data.active = false"
                  block
                  type="info"
                  native-type="button"
                  style="{width: 100%;display: inline-block;border:0;border-right-style: solid;border-width: 1px;}"
                >取消</van-button>
              </div>
              <div style="width: 50%;display: inline-block;float: right;">
                <van-button
                  block
                  type="info"
                  native-type="submit"
                  style="{width: 100%;display: inline-block;border:0;}"
                  @click="formConfirm"
                >確定</van-button>
              </div>
            </div>
          </van-form>
        </div>
      </div>
    </van-overlay>
    <van-popup v-model="showFormType" position="bottom">
      <van-picker
        show-toolbar
        :columns="this.notifyType"
        @confirm="formTypeConfirm"
        @cancel="showFormType = false"
        confirm-button-text="確認"
      />
    </van-popup>
  </div>
</template>

<script>
import { Dialog } from "vant";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      showFormType: false,
      notifyType: ["合作洽談", "問題回報", "廣告興趣", "其它"],
      choseType: "",
      notifyMessage: "",
      realName: "",
      realTel: "",
      industryType: ""
    };
  },
  computed: {
    ...mapGetters(["liffUserData"])
  },
  props: ["data"],
  created() {
    this.choseType = this.data.name;
  },
  methods: {
    formTypeConfirm(value) {
      this.choseType = value;
      this.showFormType = false;
    },
    formConfirm() {
      this.data.active = false;
      let text =
        this.choseType == "合作洽談" ? `產業別:${this.industryType}` : "";
      text += `類型:${this.choseType} 真名:${this.realName} 電話:${this.realTel} 訊息:${this.notifyMessage} line名稱:${this.liffUserData.displayName} line ID:${this.liffUserData.userId}`;
      fetch(`${process.env.VUE_APP_APIURL}/notify`,{
        method: "POST",
        body: JSON.stringify({
            'message':`APP回傳 ${text}`,
          }),
      });
      Dialog.alert({
        title: "送出成功",
        confirmButtonText: "確認"
      });
    }
  }
};
</script>

<style>
</style>